import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";

import { App } from "./src/components/App";

const root = ReactDOM.createRoot(document.getElementById("app-root")!);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
